import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import LoadingSpinnerInline from "../../ui/LoadingSpinnerInline"

const getStatusColor = (status) => {
  switch (status) {
    case "pending":
      return "turquoise"
    case "success":
      return "green"
    case "failed":
      return "red"
    default:
      return "black"
  }
}

const StatusComponent = styled.div`
  color: ${(props) => getStatusColor(props.status)};
`

const StatusText = ({ status }) => {
  return (
    <StatusComponent status={status}>
      {status === "pending" && <LoadingSpinnerInline />}
      {status}
    </StatusComponent>
  )
}

StatusText.propTypes = {
  status: PropTypes.string,
}

export default StatusText
